import { createReducer, on } from '@ngrx/store';
import {
  loadKoddiAds,
  loadKoddiAdsSuccess,
  loadKoddiAdsFailure,
  clearKoddiAds
} from '../../actions/koddi-ads/koddi-ads.actions';
import { IKoddiAdsData, IKoddiAdsError } from 'src/app/models/cobrand-model';

export interface State {
  loading: boolean;
  error: IKoddiAdsError | null;
  adsByPageId: { [pageId: string]: IKoddiAdsData[] | null };
}

export const initialState: State = {
  loading: false,
  error: null,
  adsByPageId: {},
};

export const reducer = createReducer(
  initialState,

  on(loadKoddiAds, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(loadKoddiAdsSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    adsByPageId: {
      ...state.adsByPageId,
      [payload.pageId]: payload.data
    }
  })),

  on(loadKoddiAdsFailure, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload.error,
    adsByPageId: {
      ...state.adsByPageId,
      [payload.pageId]: null
    }
  })),

  on(clearKoddiAds, () => initialState)
);
export const getKoddiAdsState = (state: State) => state;
export const getKoddiAdsLoading = (state: State) => state.loading;
export const getKoddiAdsError = (state: State) => state.error;
export const getKoddiAdsByPageId = (state: State, pageId: string) => state.adsByPageId[pageId];
export const getAllKoddiAds = (state: State) => state.adsByPageId;
